const companiesGrid = Object.freeze({
  emptyTitle: "Компаній не знайдено",
  emptySubtitle: "На даний момент для ваших фільтрів немає компаній.",
  createCompany: "Додати Компанію",
  jobs: "вакансій",
  clearFiltersButton: "Очистити всі фільтри",
});

export default companiesGrid;
